import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.036 4.806c-1.466-.06-2.896.357-4.023 1.157C4.887 6.762 4.147 7.88 3.9 9.096c-.245 1.214.01 2.472.737 3.547a.8.8 0 0 1 .096.7l-.533 1.6 2.157-.46a.8.8 0 0 1 .516.063c1.276.62 2.77.809 4.2.526 1.429-.284 2.673-1.015 3.514-2.035.838-1.017 1.221-2.253 1.1-3.48-.12-1.227-.739-2.395-1.773-3.278-1.036-.883-2.414-1.414-3.88-1.473m-4.95-.148c1.43-1.014 3.212-1.524 5.014-1.451s3.529.725 4.853 1.855c1.326 1.131 2.165 2.67 2.328 4.34.164 1.67-.363 3.324-1.458 4.653-1.093 1.326-2.675 2.237-4.439 2.586a8.3 8.3 0 0 1-4.953-.537l-3.265.694a.8.8 0 0 1-.925-1.035l.855-2.565a6.22 6.22 0 0 1-.763-4.42c.333-1.645 1.323-3.105 2.754-4.12",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }